<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-row justify="center" class="mt-n8 mx-1 mb-4">
          <v-icon class="mx-2" size="35px">mdi-account-cash</v-icon>
          <span style="font-size: 34px; color: #616161">Retenciones de Suplidores</span>
        </v-row>
        <v-row justify="center" class="mb-1 mt-n4">
          <v-col cols="12" sm="6" md="4" lg="3" class="py-1">
            <v-autocomplete
              class="mt-5"
              dense
              outlined
              v-model="business_selected"
              :items="itemsBussines"
              label="Unidad de negocio"
              color="cyanText"
              prepend-inner-icon="corporate_fare"
              required
              @change="onBusinessChange"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="py-1">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="mt-5"
                  v-model="selectedMonthName"
                  label="Seleccionar mes"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="selectedMonth"
                type="month"
                no-title
                scrollable
                @input="onDateSelected"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="confirmSelection">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
    
        <v-card class="rounded-lg mt-n3">
          <v-expand-transition>
            <v-row v-if="loading" justify="center">
              <v-col cols="12" md="10">
                <v-skeleton-loader
                  type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
                >
                </v-skeleton-loader>
              </v-col>
            </v-row>
            <v-data-table
              v-else
              height="60vh"
              :search="search"
              :headers="headers"
              :items-per-page="15"
              :items="suplidores"
              class="elevation-0"
              dense
              hide-default-footer
              @page-count="pageCount = $event"
              :page.sync="page"
            >
              <template v-slot:top>
                <v-toolbar class="elevation-0 rounded-lg">
                  <v-toolbar-title>Suplidores ({{ suplidores.length }})</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-spacer></v-spacer>
                  <v-text-field
                    label="Buscar..."
                    class="mt-6"
                    v-model="search"
                    prepend-icon="mdi-magnify"
                  ></v-text-field>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" dark class="mb-2" @click="exportToExcel">
                    <v-icon left>mdi-microsoft-excel</v-icon>
                    Exportar a Excel
                  </v-btn>
                </v-toolbar>
              </template>
         
              <template v-slot:[`item.total_to_pay`]="{ item }">
                <span>{{ currencyFormat(item.total_to_pay) }}</span>
              </template>
              <template v-slot:[`item.total_withholdings`]="{ item }">
                <span>{{ currencyFormat(item.total_withholdings) }}</span>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      color="primary"
                      @click="openPdfDialog(item)"
                      medium
                    >
                      mdi-printer
                    </v-icon>
                  </template>
                  <span>Imprimir retención</span>
                </v-tooltip>
              </template>
              <template v-slot:no-data>
                <v-row justify="center" class="pt-10">
                  <v-icon size="80px">mdi-alert-circle-outline</v-icon>
                </v-row>
                <v-row justify="center" class="pb-6">No hay datos disponibles</v-row>
              </template>
              <template slot="footer">
                <v-row justify="center">
                  <v-container style="width: 70%" class="mt-4">
                    <v-pagination v-model="page" :length="pageCount"></v-pagination>
                  </v-container>
                </v-row>
              </template>
            </v-data-table>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogRetencion" max-width="600px">
      <v-card>
        <v-card-title class="headline">Carta de Retención</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6">
              <p><strong>Suplidor:</strong> {{ selectedSuplidor.nombre }}</p>
              <p><strong>RNC/Cédula:</strong> {{ selectedSuplidor.rncCedula }}</p>
              <p><strong>Mes de retención:</strong> {{ selectedMonthName }}</p>
            </v-col>
            <v-col cols="12" sm="6">
              <p>
                <strong>Monto de retención:</strong>
                {{ currencyFormat(selectedSuplidor.montoRetencion) }}
              </p>
              <p>
                <strong>Concepto:</strong> Retención de impuestos según la ley vigente
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <p>
                Por medio de la presente, certificamos que hemos retenido el monto
                indicado arriba en concepto de impuestos, de acuerdo con las regulaciones
                fiscales aplicables.
              </p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogRetencion = false">Cerrar</v-btn>
          <v-btn color="blue darken-1" text @click="openPdfDialog(selectedSuplidor)">Imprimir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPdf" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialogPdf = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>PDF de Retención</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="printPdf">Imprimir</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row justify="center" align="center" style="height: 100%;">
              <v-col cols="12">
                <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="800px" frameborder="0"></iframe>
                <v-progress-circular v-else indeterminate color="primary"></v-progress-circular>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: 'WithholdingsSuppliers',
  data() {
    return {
      loading: false,
      search: "",
      dialogPdf: false,
      pdfUrl: null,
      page: 1,
      pageCount: 0,
      menu: false,
      itemsBussines: [],
      selectedMonth: null,
      selectedMonthName: 'Seleccionar mes',
      startDate: null,
      endDate: null,
      headers: [
        { text: "Nombre del Suplidor", align: "start", sortable: true, value: "entity_name" },
        { text: "RNC/Cédula", value: "document_id_type_name" },
        { text: "Monto de Facturas", value: "total_to_pay" },
        { text: "Monto de Retención", value: "total_withholdings" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      suplidores: [],
      dialogRetencion: false,
      selectedSuplidor: {},
    };
  },

  computed: {
    business_selected: {
      get() {
        return this.$store.state.app.filters.business;
      },
      set(value) {
        this.$store.commit("setBusiness", value);
      },
    },
  },

  methods: {
    onDateSelected(date) {
      this.selectedMonth = date;
      this.updateDates();
    },

    updateDates() {
      if (this.selectedMonth) {
        const [year, month] = this.selectedMonth.split('-');
        const date = new Date(year, month - 1, 1); // month - 1 porque los meses en JavaScript van de 0 a 11
        this.selectedMonthName = this.formatDate(date);
        this.startDate = new Date(year, month - 1, 1);
        this.endDate = new Date(year, month, 0);
      } else {
        this.selectedMonthName = 'Seleccionar mes';
        this.startDate = null;
        this.endDate = null;
      }
    },

    formatDate(date) {
      const options = { month: 'long', year: 'numeric' };
      return date.toLocaleDateString('es-ES', options).replace(/^\w/, (c) => c.toUpperCase());
    },

    formatFullDate(date) {
      return date.toISOString().split('T')[0];
    },


    confirmSelection() {
      this.updateDates();
      this.menu = false;
      this.getData();
    },

    onBusinessChange() {
      this.getData();
    },

    async getData() {
      if (!this.startDate || !this.endDate || !this.business_selected) {
        this.suplidores = [];
        return;
      }

      this.loading = true;
      try {
        
        const responseRequest = await this.api_Post("income/search_supplier_withholding", {
          business: this.business_selected,
          start_date: this.formatFullDate(this.startDate),
          end_date:  this.formatFullDate(this.endDate)
       
        });

        if (responseRequest.status == 200) {
          let data=await responseRequest.json()
     
          this.suplidores = data
        } else {
          this.$toast.error("error al crear la cuenta!");
        }
    
      } catch (error) {
        console.error('Error al obtener los datos:', error);
        // Aquí puedes manejar el error, por ejemplo, mostrando un mensaje al usuario
      } finally {
        this.loading = false;
      }
    },

    showRetencion(item) {
      this.selectedSuplidor = item;
      this.dialogRetencion = true;
    },
    async openPdfDialog(item) {
      this.dialogRetencion = false;
      this.dialogPdf = true;
      this.pdfUrl = null;
   

      let filters={
          business: this.business_selected,
          start_date: this.formatFullDate(this.startDate),
          end_date:  this.formatFullDate(this.endDate),
          entity_id: item.entity_id
        }
      
      try {
        this.loading = true;
        const responseDataPdf = await this.api_Post("income/view_withholding_pdf",filters);

        const blob = await responseDataPdf.blob();
        this.pdfUrl = URL.createObjectURL(blob);
      } catch (error) {
        console.error('Error al obtener el PDF:', error);
        this.$toast.error("Error al cargar el PDF de retención");
      } finally {
        this.loading = false;
      }
    },
    printRetencion(item) {
      const printContent = `
        <html>
          <head>
            <title>Carta de Retención</title>
            <style>
              body { font-family: Arial, sans-serif; }
              h2 { color: #333; }
              .content { margin: 20px; }
            </style>
          </head>
          <body>
            <div class="content">
              <h2>Carta de Retención</h2>
              <p><strong>Suplidor:</strong> ${item.nombre}</p>
              <p><strong>RNC/Cédula:</strong> ${item.rncCedula}</p>
              <p><strong>Mes de retención:</strong> ${this.selectedMonthName}</p>
              <p><strong>Monto de retención:</strong> ${this.currencyFormat(item.montoRetencion)}</p>
              <p><strong>Concepto:</strong> Retención de impuestos según la ley vigente</p>
              <p>Por medio de la presente, certificamos que hemos retenido el monto indicado
              arriba en concepto de impuestos, de acuerdo con las regulaciones fiscales
              aplicables.</p>
            </div>
          </body>
        </html>
      `;
      const printWindow = window.open("", "_blank");
      printWindow.document.write(printContent);
      printWindow.document.close();
      printWindow.print();
    },

    currencyFormat(value) {
      return new Intl.NumberFormat("es-DO", {
        style: "currency",
        currency: "DOP",
      }).format(value);
    },

    exportToExcel() {
      // Implementar lógica de exportación a Excel aquí
      // Aquí deberías implementar la lógica real para exportar a Excel
      // Podrías usar una librería como SheetJS (xlsx) para generar el archivo Excel
    },
  },

  created() {
    // Cargar las unidades de negocio al crear el componente
    this.itemsBussines = Object.assign([], this.$store.state.auth.bussines_units);
  },
};
</script>

<style scoped>
.v-data-table >>> tbody tr:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}
</style>